export interface iCheckoutOrderReview {
  purchaseOrderNumber?: string;
  requestedDeliveryDate?: string;
  deliveryAddress?: iShippingAddressArray | any;
}
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  ActiveCartService,
  MultiCartService,
  RoutingService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { iShippingAddressArray } from '../../cart/cart.model';
import { CartService } from '../../cart/cart.service';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss'],
})
export class OrderConfirmationComponent implements OnInit, OnDestroy {
  shiptoObj: iCheckoutOrderReview = {};
  orderData: any;

  constructor(
    public activeCartService: ActiveCartService,
    public cdf: ChangeDetectorRef,
    public cartService: CartService,
    public routingService: RoutingService,
    public multiCartService: MultiCartService,
    public userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.cartService.$orderPlaceResponse.subscribe((orderData) => {
      console.log('xxxx',orderData);
      if (orderData && orderData.entries?.length > 0) {
        this.processOrderData(orderData);
        localStorage.removeItem('orderData');
        localStorage.setItem('orderData', JSON.stringify(orderData));
        this.cartService.loadCarts().subscribe((data) => {
          if (data.carts?.length > 0) {
            this.multiCartService.reloadCart(data.carts[0]?.code, {
              active: true,
            });
          }
        });
      } else {
        let sessionOrderData = JSON.parse(
          localStorage.getItem('orderData') || '{}'
        );
        if (sessionOrderData) {
          this.processOrderData(sessionOrderData);
        } else {
          this.routingService.go('/my-account/orders');
        }
      }
      this.cdf.detectChanges();
    });
  }

  processOrderData(orderData: any) {
    this.orderData = orderData;
    let delivery_date = orderData.expectedDeliveryDate?.split('T')[0]
      ? orderData.expectedDeliveryDate?.split('T')[0]
      : '';
    this.shiptoObj = {
      deliveryAddress: orderData.deliveryAddress,
      purchaseOrderNumber: orderData?.purchaseOrderNumber,
      requestedDeliveryDate: delivery_date,
    };
  }

  ngOnDestroy(): void {
    localStorage.removeItem('orderData');
  }
}
